
import React from "react";
import { Switch } from "@/components/ui/switch";
import { MetricTooltip } from "../../advanced/analytics/MetricTooltip";

interface AutoCalculateToggleProps {
  enabled: boolean;
  onToggle: (checked: boolean) => void;
}

const AutoCalculateToggle: React.FC<AutoCalculateToggleProps> = ({ 
  enabled, 
  onToggle 
}) => {
  return (
    <div className="flex items-center space-x-2">
      <Switch
        checked={enabled}
        onCheckedChange={onToggle}
      />
      <span className="text-sm text-muted-foreground">Auto-Calculate <MetricTooltip metric="autoCalculateClosing" /></span>
    </div>
  );
};

export default AutoCalculateToggle;
